import { HttpHeaders } from '@angular/common/http';
import { Injectable, ViewChild } from '@angular/core';
import { Network } from '@ionic-native/network';
import { ApiProvider } from '../api/api'
import { Observable } from 'rxjs/Observable';
import { LoginResponse, User, LoginParams, ApiResponseGeneric } from '../../models/apiResponse';
import { MaestrosResult, Equipos, Personal, Tipochecklist, ViajesResult, RegresosResult, ControlEquiposResult  } from '../../models/maestros';
import { Storage } from '@ionic/storage';
import { Viaje, Regreso } from '../../models/viaje';
import { Controles } from '../../models/controlequipos';
import { Parametros } from '../../models/parametros';
import { ControlEquipoResult } from '../../models/ControlEquipoResult';
import { from } from 'rxjs/observable/from';
import { AlertController, Nav } from 'ionic-angular';
/*
  Generated class for the DataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DataProvider {

  @ViewChild(Nav) nav: Nav;

  public todosSectores: boolean = false;
  public filtroSectores: Array<number> = new Array;

  public getDetallesChecklist(checklistId: number): Observable<Tipochecklist> {

    return Observable.create((observer) => {

      this.storage.get(this.STORAGE_KEY_CHKLISTS)
        .then((all: Array<Tipochecklist>) => {
          let checklist = all.find(a => a.id == checklistId);
          observer.next(checklist);
        });

    });
  }

  private readonly STORAGE_KEY_EQUIPOS = "Maestros_equipos";
  private readonly STORAGE_KEY_PERSONAL = "Maestros_personal";
  private readonly STORAGE_KEY_CHKLISTS = "Maestros_tipochecklist";
  private readonly STORAGE_KEY_CONTROLES = "Maestros_tipocontroles";
  private readonly STORAGE_KEY_PARAMETROS = "Maestros_parametros";
  private readonly STORAGE_KEY_REGRESOS = "Regresos";
  private readonly STORAGE_KEY_VIAJES = "Viajes";
  private readonly STORAGE_KEY_CONTROLEQUIPO = "ControlEquipos";

  public getEquipos(): Observable<Array<Equipos>> {
    return this.getMaestroFromStorage(this.STORAGE_KEY_EQUIPOS);
  }

  public getPersonal(): Observable<Array<Personal>> {
    return this.getMaestroFromStorage(this.STORAGE_KEY_PERSONAL);
  }

  public getChecklist(): Observable<Array<Tipochecklist>> {
    return this.getMaestroFromStorage(this.STORAGE_KEY_CHKLISTS);
  }

  private getMaestroFromStorage<T>(key: string): Observable<Array<T>> {
    return from(this.storage.get(key));
  }

  public getAllviajes(): Observable<Array<Viaje>> {
    return this.getMaestroFromStorage(this.STORAGE_KEY_VIAJES);
  }

  public getRegresos(): Observable<Array<Regreso>> {
    return this.getMaestroFromStorage(this.STORAGE_KEY_REGRESOS);
  }

  public getControles(): Observable<Array<Controles>> {
    return this.getMaestroFromStorage(this.STORAGE_KEY_CONTROLEQUIPO);
  }

  public getParams(): Observable<Array<Parametros>> {
    return this.getMaestroFromStorage(this.STORAGE_KEY_PARAMETROS);
  }

  public getRegresosNoSync(): Observable<number> {
    return Observable.create((observer) => {
      let regresos: Array<Regreso>;
      let cant: number;
      this.storage.get(this.STORAGE_KEY_REGRESOS).then(all => {
          regresos=all;
          if(regresos==null){
            cant=0;
          } else {
            cant = regresos.length;
          }
          observer.next(cant);
      });
    })
  }

  public getControlesNoSync(): Observable<number> {
    return Observable.create((observer) => {
      let controles: Array<Controles>;
      let cant: number;
      this.storage.get(this.STORAGE_KEY_CONTROLEQUIPO).then(all => {
          controles=all;
          if(controles==null){
            cant=0;
          } else {
            cant = controles.length;
          }
          observer.next(cant);
      });
    })
  }

  constructor(private network: Network, private api: ApiProvider, private storage: Storage, public alertCtrl: AlertController) {
    let us: User = this.loggedUser;
    if(us){
      let aux: Array<String> = us.filtroSectores.toString().split(",");
      let fil: Array<number> = new Array;
      aux.forEach(e => {
        fil.push(Number(e));
      });
      this.filtroSectores = fil;
      this.todosSectores = us.todosSectores;
    }

    console.log("Data filtroSectores",this.filtroSectores);
  }

  private get access_token(): string { return localStorage["access_token"]; }
  private set access_token(token: string) { localStorage["access_token"] = token; }

  public get user_despacho(): number { return localStorage["user_despacho"]; }
  public set user_despacho(permiso: number) { localStorage["user_despacho"] = permiso; }


  public get user_plantilla(): number { return localStorage["user_plantilla"]; }
  public set user_plantilla(permiso: number) { localStorage["user_plantilla"] = permiso; }

  /**
   * Gets the user currently logged on
   */
  public get loggedUser(): User {
    if(localStorage["user"]){
      return JSON.parse(localStorage["user"]);
    } else {
      return null;
    }
  }

  /**
   * Sets the user currently logged on
   */
  private set internalLoggedUser(user: User) { localStorage["user"] = JSON.stringify(user); }

  /**
   * Indicates whether there is a user logged on the
   * app
   */
  public get isLoggedOn(): boolean {return !!this.access_token; }

  private setAuthData(loginResponse: LoginResponse) {

    console.log("setAuthData: loginResponse: ", loginResponse);

    this.access_token = loginResponse.access_token;
    this.internalLoggedUser = loginResponse.user;
    this.user_despacho = loginResponse.despachos;

    console.log("setAuthData: user_despacho: ", this.user_despacho);

    let aux: Array<String> = loginResponse.user.filtroSectores.toString().split(",");
      let fil: Array<number> = new Array;
      aux.forEach(e => {
        fil.push(Number(e));
      });
      this.filtroSectores = fil;
      this.todosSectores = loginResponse.user.todosSectores;

  }

  private getDefaultHeaders(): Object {

    let at = this.access_token;
    if (at) {
        let options = {
          headers: new HttpHeaders().append('AUTHORIZATION_HEADER',"Token " + at)
        }
        return options;
    }

  }

  /**
   * Tries to log the user on the server
   */
  public logOn(account: LoginParams): Observable<boolean> {

    return Observable.create((observer) => {
      //si hay un usuario logueado eliminar los datos antes
      if(this.isLoggedOn){
        this.logOut();
      }

      //let opts = { headers: this.getDefaultHeaders() };
      let opts = {
        headers: new HttpHeaders().append("Content-Type", "application/x-www-form-urlencoded")
      }
      //opts.headers = opts.headers.set("Content-Type", "application/x-www-form-urlencoded");

      let postStr = "username=" + account.username + "&password=" + account.password;

      this.api.post("login", postStr, opts).subscribe((response: any) => {

        console.log("logOn response: ", response );

        let apiResponse: ApiResponseGeneric<LoginResponse> = response;

        if (apiResponse.success && apiResponse.result.access_token) {
          this.setAuthData(apiResponse.result);
          observer.next(true);
        } else {
          observer.next(false);
        }
        
       // return para evitar emitir un valor adicional.
        return;
      });

    });

  }

  public logOut(){

    console.log("logOut");

    localStorage.removeItem('user'); 
    localStorage.removeItem('access_token');
    
    console.log('Token',localStorage.getItem('access_token'));
    //console.log('User',localStorage.getItem('user'));
    //console.log('localStorage',localStorage);

  }

  public isOffline(): boolean {
    return (this.network.type == this.network.Connection.UNKNOWN || this.network.type === this.network.Connection.NONE);
  }

  public getMaestros(): Observable<boolean> {

    let header = this.getDefaultHeaders();
    console.log("Headers dentro de Maestros", header);

    return Observable.create((observer) => {

      this.api.get("maestros", null, header).subscribe((response: any) => {

        console.log("maestros", response);

        let apiResponse: ApiResponseGeneric<MaestrosResult> = response;
        if (!apiResponse.success) {
          if(apiResponse.unauthorized==true){
            console.log("Token Invalido");
            localStorage.removeItem('access_token');
            localStorage.removeItem('user');
            //this.nav.push(LoginPage);
          }
          observer.next(false);
          return;
        }

        this.storage.set(this.STORAGE_KEY_EQUIPOS, apiResponse.result.equipos);
        this.storage.set(this.STORAGE_KEY_PERSONAL, apiResponse.result.personal);
        this.storage.set(this.STORAGE_KEY_CHKLISTS, apiResponse.result.tipochecklist);
        this.storage.set(this.STORAGE_KEY_CONTROLES, apiResponse.result.tipocontroles);
        this.storage.set(this.STORAGE_KEY_PARAMETROS, apiResponse.result.parametros);

        observer.next(true);

      }, (error: any) => observer.error(error));

    });

  }

  public getViajes(): Observable<boolean> {

    return Observable.create((observer) => {

      this.api.get("viajes", null, this.getDefaultHeaders()).subscribe((response: any) => {

        console.log("viajes", response);

        let apiResponse: ApiResponseGeneric<ViajesResult> = response;
        if (!apiResponse.success) {
          observer.next(false);
          return;
        }

        this.storage.set(this.STORAGE_KEY_VIAJES, apiResponse.result.viajes);

        observer.next(true);

      },
        (error) => observer.error(error));
    });
  }

  public addControlEquipo(controlequipo: ControlEquipoResult): Observable<Array<any>>{


    console.log(controlequipo);
    return Observable.create((observer)=> {
      let result = new Array;
      let controlequipos: Array<ControlEquipoResult>;

      this.storage.get(this.STORAGE_KEY_CONTROLEQUIPO).then(all => {
            controlequipos = all;
            if(controlequipos==null){
              controlequipos = new Array<ControlEquipoResult>();
            }
            controlequipos.push(controlequipo);
            this.storage.set(this.STORAGE_KEY_CONTROLEQUIPO,controlequipos);
            result['ok']=true;
            result['mensaje']="";

            observer.next(result);
          }
      );
    });
  }

  public addRegresoViaje(regreso: Regreso): Observable<Array<any>> {
    console.log('addRegreso',regreso);

    return Observable.create((observer)=> {

        let result = new Array;
        let regresos: Array<Regreso>;
        let viajes: Array<Viaje>;

        this.storage.get(this.STORAGE_KEY_REGRESOS).then(all => {
              regresos = all;
              if(regresos==null){
                regresos = new Array<Regreso>();
              }
              regresos.push(regreso);
              this.storage.set(this.STORAGE_KEY_REGRESOS,regresos);
              result['ok']=true;
              result['mensaje']="";

              //Marco el viaje como cerrado
              this.storage.get(this.STORAGE_KEY_VIAJES).then(vi => {
                viajes = vi;

                for(let i=0;i<viajes.length;i++){
                  if(viajes[i].id==regreso.idviaje){
                    viajes[i].kmfinal = regreso.kmfinal;
                    this.storage.set(this.STORAGE_KEY_VIAJES,viajes);
                    i=100000000;
                  }
                }
              });

              observer.next(result);
            }
        );
    });

  }

  public RemoverRegresos(){
    let regresos: Array<Regreso>;
    this.storage.get(this.STORAGE_KEY_REGRESOS).then(all => {
      regresos = all;
      console.log('all regresos',regresos);
      if(regresos!=null){
        for(let r=0;r<regresos.length;r++){
          regresos.splice(r);
        }
      }
    });

    this.storage.set(this.STORAGE_KEY_REGRESOS,regresos);


  }
  public RemoverControles(){
    let controlequipos: Array<Controles>;
    this.storage.get(this.STORAGE_KEY_CONTROLEQUIPO).then(all => {
      controlequipos = all;
      console.log('all controles',controlequipos);
      if(controlequipos!=null){
        for(let r=0;r<controlequipos.length;r++){
          controlequipos.splice(r);
        }
      }
    });

    this.storage.set(this.STORAGE_KEY_CONTROLEQUIPO,controlequipos);

  }

  public removerDatosPendientes(){

    this.RemoverControles();
    this.RemoverRegresos();

  }

  public sincronizarDatosControlEquipo(): Observable<Array<any>> {

    let isOnline = !this.isOffline();
    console.log("sincronizar online ctrl eq=",isOnline);

    if(1==1){

      return Observable.create((observer) => {
        let controlequipos: Array<Controles>;

        this.storage.get(this.STORAGE_KEY_CONTROLEQUIPO).then(all => {
            controlequipos = all;

            if(controlequipos!=null){

              console.log('controlequipos', controlequipos);

              this.api.post("postDespachos", controlequipos, this.getDefaultHeaders()).subscribe((response: any) => {
                console.log("postDespachos", response);
                let apiResponse: ApiResponseGeneric<ControlEquiposResult> = response;
                if (!apiResponse.success) {
                  observer.next(false);
                  return;
                }
                let regs = apiResponse.result.controlequipos;
                for(let i=0;i<regs.length;i++){
                  for(let r=0;r<controlequipos.length;r++){
                    if(controlequipos[r].uid==regs[i].uid){
                      if(regs[i].error){
                        controlequipos[r].errorSincro = regs[i].msjError;
                        controlequipos[r].fechaSincro = new Date().toISOString();
                      } else {
                        controlequipos.splice(r);
                      }
                      r=100000000;
                    }
                  }
                }
                this.storage.set(this.STORAGE_KEY_CONTROLEQUIPO,controlequipos);
                observer.next(true);
              }
              ,(error) => observer.error(error));
            }
        });
      });
    }
  }

  public sincronizarDatos(): Observable<Array<any>> {
    let isOnline = !this.isOffline();
    console.log("sincronizar online=",isOnline);
//isOnline
    if(1==1){
      return Observable.create((observer) => {
        let regresos: Array<Regreso>;
        this.storage.get(this.STORAGE_KEY_REGRESOS).then(all => {
            regresos = all;
            if(regresos!=null){
              this.api.post("postRegresos", regresos, this.getDefaultHeaders()).subscribe((response: any) => {
                console.log("postRegresos", response);
                let apiResponse: ApiResponseGeneric<RegresosResult> = response;
                if (!apiResponse.success) {
                  observer.next(false);
                  return;
                }
                let regs = apiResponse.result.regresos;
                for(let i=0;i<regs.length;i++){
                  for(let r=0;r<regresos.length;r++){
                    if(regresos[r].idviaje==regs[i].idviaje){
                      if(regs[i].error){
                        regresos[r].errorSincro = regs[i].msjError;
                        regresos[r].fechaSincro = new Date().toISOString();
                      } else {
                        regresos.splice(r);
                      }
                      r=100000000;
                    }
                  }
                }
                this.storage.set(this.STORAGE_KEY_REGRESOS,regresos);
                observer.next(true);
              }
              ,(error) => observer.error(error));
            }
        });
      });
    }
  }



}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts